import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  sendQuickScheduleMessageRequest,
  sendQuickScheduleMessageSuccess,
  sendQuickScheduleMessageFailure,
} = createActions({
  SEND_QUICK_SCHEDULE_MESSAGE_SUCCESS: json => ({
    phase: json.phase || json,
  }),
}, 'SEND_QUICK_SCHEDULE_MESSAGE_REQUEST', 'SEND_QUICK_SCHEDULE_MESSAGE_FAILURE');

export function sendQuickScheduleMessage(phaseID, apptParams) {
  return (dispatch) => {
    dispatch(sendQuickScheduleMessageRequest());
    const req = {
      method: 'POST',
      body: { appt_params: apptParams },
    };
    return request(`phases/${phaseID}/quick_schedule`, req)
      .then(({ json }) => dispatch(sendQuickScheduleMessageSuccess(json)))
      .catch(error => dispatch(sendQuickScheduleMessageFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/quick_schedule.js